import { BRAND } from '../brand';

export function Fallback({ reason }: { reason: 'webgl' | 'load' }) {
  return (
    <main class="fallback" data-testid="fallback">
      <img src="/icon.svg" alt="" width="64" height="64" />
      <h1>{reason === 'webgl' ? 'Your browser can’t show the 3D body' : 'The 3D body didn’t load'}</h1>
      <p>
        {reason === 'webgl'
          ? `${BRAND.name} needs WebGL 2, which this browser or device doesn’t support (or has switched off). A recent Chrome, Edge, Firefox or Safari will work.`
          : 'This is usually a flaky connection. Try reloading the page.'}
      </p>
      <p>
        You can still read every card: start with <a href="/s/heart/">the heart</a> or <a href="/s/ulnar-nerve/">the “funny bone”</a>.
      </p>
    </main>
  );
}
